import AppButton from "@/components/AppButton.vue";
import BannerPwa from "@/components/BannerPwa.vue";
import EmptyState from "@/components/EmptyState.vue";
import HeaderFluxo from "@/components/HeaderFluxo.vue";
import StoreCard from "@/components/HorizontalStoreCard.vue";
import InputText from "@/components/InputText.vue";
import LoadingPhases from "@/components/LoadingPhases.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import TextLink from "@/components/TextLink.vue";
import { getApplicationUrl } from "@/config";
import HomeContainer from "@/containers/HomeContainer.vue";
import Request from "@/ts/Request";
import Util from "@/ts/Util";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    TextLink,
    InputText,
    AppButton,
    HeaderFluxo,
    StoreCard,
    ModalCodigo,
    EmptyState,
    LoadingPhases,
    HomeContainer,
    BannerPwa,
  },
})
export default class HomeLojas extends Vue {
  stores: any = JSON.parse(sessionStorage.getItem("stores") || "[]") || [];
  filteredStores: any = this.stores;
  storesLoaded = false;
  showModalTelaCartoes = false;
  mainCartao: any = JSON.parse(sessionStorage.getItem("MAIN_CARTAO") || "{}");
  card: any;
  creditCards: Array<object> = [];
  userData: any = JSON.parse(sessionStorage.getItem("USER_DATA") || "[]");
  lastDate: any = sessionStorage.getItem("LAST_DAY_ESCOLHER_UNIDADE") || "";
  chooseStructure: any =
    sessionStorage.getItem("NEED_TO_CHOOSE_THE_STRUCTURE") || "1";
  userAddress: any = {};
  formattedAddress = "";
  showModal = false;
  currentLatitude: any = "";
  currentLongitude: any = "";
  useCurrentLocation = false;
  emptyStateMessage = "Carregando lojas próximas...";
  homeLayout = sessionStorage.getItem("HOME_LAYOUT") || "feed";
  componentKey = 0;
  notificationsKey = 1;
  logo = sessionStorage.getItem("ORGANIZATION_LOGO") || "";
  store: any = JSON.parse(sessionStorage.getItem("STORE") || "{}");
  loadedStores: boolean = sessionStorage.getItem("stores") ? true : false;
  organizationData: any =
    JSON.parse(sessionStorage.getItem("ORGANIZATION_DATA") || "{}") || {};
  showModalLogoff = false;

  created() {
    Util.removeTableData();
    if (this.homeLayout == "HomeLojas") {
      sessionStorage.setItem("HAS_HOME", "true");
    }
    if (this.userData.ADDRESS)
      this.userAddress = this.userData.ADDRESS.find(
        (address: any) => address.TYPE == "DELIVERY"
      );
    else if (sessionStorage.getItem("PROVISORY_ADDRESS"))
      this.userAddress =
        JSON.parse(sessionStorage.getItem("PROVISORY_ADDRESS") || "{}") || {};
    if (this.userAddress && this.userAddress.PROVINCY == "DF") {
      this.formattedAddress = Util.capitalize(this.userAddress.STREET);
    } else {
      this.formattedAddress =
        this.userAddress && this.userAddress.STREET
          ? Util.capitalize(this.userAddress.STREET) +
            ", " +
            this.userAddress.NUMBER
          : "";
    }
    this.useCurrentLocation = JSON.parse(
      sessionStorage.getItem("USE_CURRENT_LOCATION") || "false"
    );
  }

  mounted() {
    sessionStorage.removeItem("INITIAL_SCROLL_POSITION");
    const openModalLogOff = sessionStorage.getItem("openModalLogOff") || "F";
    openModalLogOff === "T" ? (this.showModalLogoff = true) : false;
    //this.getStructures().then(() => { this.getStores() });
    if (this.useCurrentLocation) {
      this.getCurrentLocation();
    } else this.getStores();
    Util.setBackButtonBehavior(this.goBack);
    if (this.stores && this.stores.length > 0) {
      if (this.stores.length == 1 && this.homeLayout !== "Lojas") {
        this.selectStoreOne(this.stores[0].id);
      }
    } else {
      this.prepareStores(this.stores);
    }
    this.getCreditCards();
    //this.getStores();
    sessionStorage.setItem("currentOrder", "");
    sessionStorage.setItem("currentItem", "");
    sessionStorage.setItem("ALL_PAYMENT_METHODS", "[]");
    sessionStorage.setItem("METHOD_SELECTED", "");
    sessionStorage.setItem("FULL_METHOD_SELECTED", "{}");
    sessionStorage.removeItem("CURRENT_TIME_SHEET");
    sessionStorage.removeItem("CURRENT_TIME_TIME_SHEET");
    sessionStorage.removeItem("DELIVERY_DATA");
  }

  getStructures() {
    return new Promise((resolve: Function, reject: Function) => {
      try {
        const req = new Request();
        req.body = {
          NRORG: sessionStorage.getItem("NRORG"),
          STRUCTURE_LEVEL: 0,
        };
        req.route = "getStructures";
        req.callbackSuccess = (response: any) => {
          const structures = response.structures;
          sessionStorage.setItem("STRUCTURES", JSON.stringify(structures));

          const result1 = this.setStructure();
          const day = JSON.stringify(moment().date());
          const chooseStructure = sessionStorage.getItem(
            "NEED_TO_CHOOSE_THE_STRUCTURE"
          );

          if (result1 && chooseStructure == "1") {
            if (!this.lastDate || day != this.lastDate) {
              this.$router.push("EscolherUnidade");
            }
            if (!sessionStorage.getItem("STRUCTURE_ID")) {
              this.$router.push("EscolherUnidade");
            }
          }
          resolve(true);
        };
        req.callbackError = function (error: any) {
          console.log(error);
        };
        req.blockTouchEvents = false;
        req.send();
      } catch (e) {
        console.log(e);
      }
    });
  }

  setStructure() {
    return new Promise((resolve: Function, reject: Function) => {
      const structures = sessionStorage.getItem("STRUCTURES");
      if (structures) {
        const arrayStructures = JSON.parse(structures);

        if (arrayStructures.length == 1) {
          sessionStorage.setItem("STRUCTURE_NAME", arrayStructures[0].name);
          sessionStorage.setItem("STRUCTURE_ID", arrayStructures[0].id);
          sessionStorage.setItem("NEED_TO_CHOOSE_THE_STRUCTURE", "0");
          resolve(true);
        } else {
          sessionStorage.setItem("NEED_TO_CHOOSE_THE_STRUCTURE", "1");
        }
      }
    });
  }

  horarioFuncionamento(day: any) {
    const date = moment().day();
    const workTime = day.filter((d: any) => d.DAY == date);
    return workTime;
  }

  verifyMainCard() {
    this.mainCartao = this.userData.MAIN_CARD_ID;
    this.card = this.findMainCard(this.mainCartao, this.creditCards);
    if (!this.card) this.showModalTelaCartoes = true;
  }

  findMainCard(mainCartao: number, cards: any) {
    return cards.find((card: any) => card.ID == mainCartao);
  }

  goBack() {
    // this.$router.push(sessionStorage.getItem('ENTERED_ORDERS_FROM') || 'MenuPedidos');
    const homeLayout = this.verifyRouteHome();
    this.$router.push(homeLayout);
  }

  fechaModal() {
    this.showModal = false;
  }

  changeStructure() {
    this.$router.push("EscolherUnidade");
  }

  selectStore(storeId: number) {
    sessionStorage.setItem("SHOW_ORDERBUTTON", JSON.stringify(false));
    sessionStorage.removeItem("STRUCTURE_ID");
    sessionStorage.removeItem("CLICK_PRODUCT");
    if (sessionStorage.getItem("STORE")) {
      if (this.store.id != storeId) {
        sessionStorage.removeItem("STORE");
        sessionStorage.removeItem("CURRENT_ORDER");
        sessionStorage.removeItem("ITEMS");
        sessionStorage.removeItem("DELIVERY_DATA");
      } else {
        sessionStorage.removeItem("STORE");
      }
    }
    if (!sessionStorage.getItem("CAME_FROM_RELEASE")) {
      sessionStorage.removeItem("DELIVER_AT");
      sessionStorage.removeItem("deliversToTable");
      sessionStorage.removeItem("deliversToBalcony");
      sessionStorage.removeItem("deliversToAddress");
      sessionStorage.removeItem("deliversToInternalLocation");
    }
    sessionStorage.setItem("storeId", storeId.toString());
    sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(false));
    sessionStorage.setItem("GO_TO_STORE", "true");
    if (
      sessionStorage.getItem("CURRENT_ORDER") &&
      storeId.toString() != sessionStorage.getItem("storeId")
    ) {
      sessionStorage.setItem("CURRENT_ORDER", "{}");
    }
    sessionStorage.setItem("storeId", storeId.toString());

    this.getIfStoreHasAnySubmenu(storeId).then((response: any) => {
      if (response) {
        sessionStorage.getItem("STORE")
          ? this.$router.push("Produtos")
          : this.goProducts();
        /* verify if the storedata is diferent and call the creditcards route again*/
      } else {
        sessionStorage.getItem("STORE")
          ? this.$router.push("ListaDeProdutos")
          : this.goProducts("ListaDeProdutos");
      }
    });
  }

  goProducts(path = "Produtos") {
    sessionStorage.setItem("loadStore", JSON.stringify(true));
    this.$router.push(path);
  }

  selectStoreOne(storeId: number) {
    sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(false));
    sessionStorage.setItem("storeId", storeId.toString());
    sessionStorage.setItem("GO_TO_STORE", "true");
    if (sessionStorage.getItem("ENTERED_FROM_ORDER")) {
      this.goBack();
    } else {
      this.getIfStoreHasAnySubmenu(storeId).then((response: any) => {
        if (response) {
          sessionStorage.getItem("STORE")
            ? this.$router.replace("Produtos")
            : this.getStoreData();
          /* verify if the storedata is diferent and call the creditcards route again*/
        } else {
          sessionStorage.getItem("STORE")
            ? this.$router.replace("ListaDeProdutos")
            : this.getStoreData(true);
        }
      });
    }
    // sessionStorage.getItem("STORE")
    //   ? this.$router.replace("Produtos")
    //   : this.getStoreData();
  }

  getStoreData(isListaDeProdutos = false) {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        STORE_ID: sessionStorage.getItem("storeId"),
        ALL_MENUS: "NO",
        DEVICE_TIME: self.getDeviceTime(),
      };
      req.route = "getStoreData";
      req.callbackSuccess = (response: any) => {
        // sessionStorage.setItem('CURRENT_ORDER', JSON.stringify(self.currentOrder));
        sessionStorage.setItem(
          "ACCEPTED_PAYMENT_METHODS",
          JSON.stringify(response.store.paymentMethods)
        );
        sessionStorage.setItem(
          "deliversToTable",
          response.store.deliversToTable
        );
        sessionStorage.setItem(
          "deliversToBalcony",
          response.store.deliversToBalcony
        );
        sessionStorage.setItem(
          "deliversToInternalLocation",
          response.store.deliversToInternalLocation
        );
        sessionStorage.setItem(
          "deliversToAddress",
          response.store.deliversToAddress
        );
        sessionStorage.setItem(
          "storePaymentMoment",
          response.store.paymentMoment
        );
        sessionStorage.setItem("STORE", JSON.stringify(response.store));
        sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(false));
        if (isListaDeProdutos) {
          this.$router.push("ListaDeProdutos");
        } else {
          this.$router.push("Produtos");
        }
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.showLoader = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  getStores() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        NRORG:
          sessionStorage.getItem("NRORG") == "0"
            ? null
            : sessionStorage.getItem("NRORG"),
        STRUCTURE_ID: null,
        LATITUDE: sessionStorage.getItem("LATITUDE"),
        LONGITUDE: sessionStorage.getItem("LONGITUDE"),
        // this.useCurrentLocation
        //   ? this.currentLatitude
        //   : this.formattedAddress
        //   ? this.userAddress.LATITUDE
        //   : null,
        // this.useCurrentLocation
        //   ? this.currentLongitude
        //   : this.formattedAddress
        //   ? this.userAddress.LONGITUDE
        //   : null,
        DEVICE_TIME: Util.getDeviceTime(),
        URL: getApplicationUrl(),
      };
      req.route = "getStoresNearUser";
      req.callbackSuccess = (response: any) => {
        const stores = response.stores;
        self.prepareStores(stores);
        sessionStorage.setItem("stores", JSON.stringify(self.stores));
        this.loadedStores = true;
        if (this.stores && this.stores.length > 0) {
          if (this.stores.length == 1 && this.homeLayout !== "Lojas") {
            if (
              this.$route.path === "/Lojas" ||
              this.$route.path === "/HomeLojas"
            ) {
              this.selectStoreOne(this.stores[0].id);
            }
          }
        } else {
          this.emptyStateMessage =
            "Não foi encontrada nenhuma loja aberta no momento nesta unidade.";
          this.prepareStores(this.stores);
        }
      };
      req.callbackError = function (error: any) {
        self.emptyStateMessage =
          "Não foi encontrada nenhuma loja aberta no momento nesta unidade.";
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.showLoader = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  prepareStores(stores: any) {
    const openedStores = stores.filter((s: any) => s.opened == true);
    const closedStores = stores.filter((s: any) => s.opened == false);

    stores = openedStores.concat(closedStores);

    this.stores = stores;
    this.filteredStores = stores;
    this.storesLoaded = true;
  }

  async getIfStoreHasAnySubmenu(storeId: number) {
    const request = new Request();
    request.route = `getIfStoreHasAnySubmenu?requestType=FilterData&STORE_ID=${storeId}`;
    request.showLoader = false;
    try {
      const response = await request.get();
      return response.ifStoreHasAnySubmenu.ifHasSubmenu;
    } catch (error) {
      console.error(error);
    }
  }

  getCreditCards() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        NRORG: sessionStorage.getItem("NRORG"),
        STORE_ID: this.store.id ? this.store.id : null,
      };
      req.route = "getValidCreditCard";
      req.callbackSuccess = function (response: any) {
        const creditCards = response.creditcards;
        self.creditCards = creditCards;
        if (response.creditcardFromParent)
          self.creditCards.push(response.creditcardFromParent);

        self.mainCartao = {};
        creditCards.forEach((card: any) => {
          if (card.IS_MAIN_CARD == true) self.mainCartao = card;
        });

        if (!self.mainCartao && !self.mainCartao.FLAG) self.mainCartao = true;
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.showLoader = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  telaCartoes() {
    this.$router.push("RegisteredCards");
  }

  goToAddAddress() {
    sessionStorage.setItem("ENTERED_ADD_ADDRESS_FROM", "Lojas");
    this.$router.push("AddAddress");

    //else
    //this.$router.replace('HomeApp');
  }

  returnToHomeAndOpenModal() {
    //sessionStorage.setItem('ENTERED_ADD_ADDRESS_FROM', 'Lojas');
    const organizationData: any =
      JSON.parse(sessionStorage.getItem("ORGANIZATION_DATA") || "{}") || {};
    // if (organizationData.CONFIGURATIONS.APP_LAYOUT_CONFIG.homeLayout == "feed"){
    //     sessionStorage.setItem('NO_ADDRESS_MODAL', 'true');
    //     this.$router.replace('HomeFeed');
    // }
    const homeLayout = this.verifyRouteHome();

    if (homeLayout == "HomeFeed" || homeLayout == "HomeRelease") {
      sessionStorage.setItem("NO_ADDRESS_MODAL", "true");
      this.$router.replace(homeLayout);
    } else {
      this.$router.replace(homeLayout);
    }
  }

  getCurrentLocation() {
    navigator.geolocation.getCurrentPosition(
      (location: any) => {
        this.currentLatitude = location.coords.latitude;
        this.currentLongitude = location.coords.longitude;
        this.getStores();
      },
      this.getStores,
      { timeout: 1000 }
    );
  }

  verifyRouteHome() {
    const util: any = new Util();
    const homeLayout: any = util.verifyRouteHome();
    return homeLayout;
  }

  getDeviceTime() {
    moment.locale("pt-br");
    const deviceTime: any = moment().format("LT");
    return deviceTime;
  }

  searchStores(searchStore: string) {
    this.filteredStores = this.stores.filter((store: any) =>
      store.name.toLowerCase().includes(searchStore.toLowerCase())
    );
    this.emptyStateMessage =
      "Não encontramos resultados correspondentes à sua pesquisa.";
  }
}
